module.exports = __webpack_public_path__ + "img/OVO.1f412d0b.svg";